import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const asnFilterOperators = unreadonly([
  ...filterOperators.asn,
  ...filterOperators.empty,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type AsnFilterOperator = (typeof asnFilterOperators)[number];

export type AsnTableFilter = TableFilterBase & {
  type: 'asn';
};

export const createAsnFilter = (): AsnTableFilter => ({
  type: 'asn',
  operators: asnFilterOperators,
});
